import { youkuClientId } from '../constants/youku-client-id';
var YoutubeThumbnailProvider = (function () {
    function YoutubeThumbnailProvider() {
    }
    YoutubeThumbnailProvider.prototype.generate = function (videoId) {
        if (videoId === void 0) { videoId = ''; }
        return new Promise(function (resolve, reject) {
            if (!videoId) {
                reject();
            }
            resolve("https://img.youtube.com/vi/" + videoId + "/maxresdefault.jpg");
        });
    };
    return YoutubeThumbnailProvider;
}());
export { YoutubeThumbnailProvider };
var YoukuThumbnailProvider = (function () {
    function YoukuThumbnailProvider() {
    }
    YoukuThumbnailProvider.prototype.generate = function (videoId) {
        if (videoId === void 0) { videoId = ''; }
        return new Promise(function (resolve, reject) {
            if (!videoId) {
                reject();
            }
            var youkuRequest = new XMLHttpRequest();
            youkuRequest.open('GET', "https://api.youku.com/videos/show.json?client_id=" + youkuClientId + "&video_id=" + videoId, true);
            youkuRequest.onreadystatechange = function () {
                if (youkuRequest.readyState !== youkuRequest.DONE) {
                    return;
                }
                if (youkuRequest.status !== 200) {
                    reject(youkuRequest.status);
                    return;
                }
                var youkuVideo = JSON.parse(youkuRequest.responseText);
                if (youkuVideo.error) {
                    reject(youkuVideo.error.code);
                }
                else {
                    resolve(youkuVideo.bigThumbnail);
                }
            };
            youkuRequest.send(null);
        });
    };
    return YoukuThumbnailProvider;
}());
export { YoukuThumbnailProvider };
